"use strict";

document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector("nav.navbar");
  if (!nav) return;

  const collapse = nav.querySelector(".navbar-collapse");
  const toggler = nav.querySelector(".navbar-toggler");
  const dropdowns = [...nav.querySelectorAll(".nav-item.dropdown")];
  const desktopPointer = () => window.matchMedia("(min-width: 768px) and (hover: hover)").matches;

  const setMenuState = (item, open) => {
    const link = item.querySelector(":scope > .dropdown-toggle");
    const menu = item.querySelector(":scope > .dropdown-menu");
    if (!link || !menu) return;
    link.classList.toggle("show", open);
    menu.classList.toggle("show", open);
    link.setAttribute("aria-expanded", String(open));
  };

  const closeAll = (except = null) => {
    dropdowns.forEach((item) => {
      if (item !== except) setMenuState(item, false);
    });
  };

  const openMenu = (item, focusFirst = false) => {
    closeAll(item);
    setMenuState(item, true);
    if (focusFirst) {
      item.querySelector(":scope > .dropdown-menu a")?.focus();
    }
  };

  if (collapse && toggler) {
    toggler.addEventListener("click", () => {
      const open = collapse.classList.toggle("show");
      toggler.setAttribute("aria-expanded", String(open));
      toggler.setAttribute("aria-label", open ? "Hauptmenü schließen" : "Hauptmenü öffnen");
      if (!open) closeAll();
    });

    toggler.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && collapse.classList.contains("show")) {
        collapse.classList.remove("show");
        toggler.setAttribute("aria-expanded", "false");
        toggler.setAttribute("aria-label", "Hauptmenü öffnen");
      }
    });
  }

  dropdowns.forEach((item) => {
    const link = item.querySelector(":scope > .dropdown-toggle");
    const menu = item.querySelector(":scope > .dropdown-menu");
    if (!link || !menu) return;

    const menuLinks = () => [...menu.querySelectorAll("a")];

    item.addEventListener("mouseenter", () => {
      if (desktopPointer()) openMenu(item);
    });

    item.addEventListener("mouseleave", () => {
      if (desktopPointer() && !item.contains(document.activeElement)) setMenuState(item, false);
    });

    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) setMenuState(item, false);
    });

    link.addEventListener("click", (event) => {
      if (!desktopPointer() && !menu.classList.contains("show")) {
        event.preventDefault();
        openMenu(item);
      }
    });

    link.addEventListener("keydown", (event) => {
      if (event.key === "ArrowDown" || event.key === " ") {
        event.preventDefault();
        openMenu(item, true);
      } else if (event.key === "Escape") {
        event.preventDefault();
        setMenuState(item, false);
        link.focus();
      }
    });

    menu.addEventListener("keydown", (event) => {
      const links = menuLinks();
      const currentIndex = links.indexOf(document.activeElement);
      let nextIndex = null;

      if (event.key === "ArrowDown") nextIndex = (currentIndex + 1) % links.length;
      if (event.key === "ArrowUp") nextIndex = (currentIndex - 1 + links.length) % links.length;
      if (event.key === "Home") nextIndex = 0;
      if (event.key === "End") nextIndex = links.length - 1;

      if (nextIndex !== null && links.length) {
        event.preventDefault();
        links[nextIndex].focus();
      } else if (event.key === "Escape") {
        event.preventDefault();
        setMenuState(item, false);
        link.focus();
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAll();
  });
});
